import {
  CropRegion,
  type ImageInputConfig,
} from "@thisissoon/flitejs-frontend";

export const defaultImgConfig: ImageInputConfig = {
  sources: [
    {
      size: "xl",
      width: 2560,
      height: 1500,
      crop: CropRegion.FocalPoint,
    },
    {
      size: "lg",
      width: 1599,
      height: 937,
      crop: CropRegion.FocalPoint,
    },
    {
      size: "md",
      width: 1279,
      height: 1166,
      crop: CropRegion.FocalPoint,
    },
    {
      size: "sm",
      width: 768,
      height: 1280,
      crop: CropRegion.FocalPoint,
    },
  ],
  fallback: {
    size: "fallback",
    width: 768,
    height: 1280,
    crop: CropRegion.FocalPoint,
  },
};

export const contentSlot1ImgConfig: ImageInputConfig = {
  sources: [
    {
      size: "xl",
      width: 800 * 2,
      height: 650 * 2,
      crop: CropRegion.FocalPoint,
    },
    {
      size: "lg",
      width: 704 * 2,
      height: 880 * 2,
      crop: CropRegion.FocalPoint,
    },
    {
      size: "md",
      width: 704 * 2,
      height: 880 * 2,
      crop: CropRegion.FocalPoint,
    },
    {
      size: "sm",
      width: 768,
      height: 1280,
      crop: CropRegion.FocalPoint,
    },
  ],
  fallback: {
    size: "fallback",
    width: 768,
    height: 1280,
    crop: CropRegion.FocalPoint,
  },
};
